export default [
  {
    path: "/profile",
    name: "Profile",
    meta: {
      layout: "profile",
    },
    redirect: { name: "ProfilePersonalInfo" },
    component: () => import("@/modules/Profile/pages/PProfile.vue"),
  },
  {
    path: "/profile/notifications",
    name: "ProfileNotifications",
    meta: {
      layout: "profile",
    },
    component: () => import("@/modules/Profile/pages/Notifications/PIndex.vue"),
  },
  {
    path: "/profile/notifications/:notificationId",
    name: "ProfileNotificationsSingle",
    meta: {
      layout: "profile",
    },
    component: () =>
      import("@/modules/Profile/pages/Notifications/PSingle.vue"),
  },
  {
    path: "/profile/personal-info",
    name: "ProfilePersonalInfo",
    meta: {
      layout: "profile",
    },
    component: () => import("@/modules/Profile/pages/PPersonalInfo.vue"),
  },
  {
    path: "/profile/personal-info/edit",
    name: "ProfilePersonalInfoEdit",
    meta: {
      layout: "profile",
    },
    component: () => import("@/modules/Profile/pages/PPersonalInfoEdit.vue"),
  },
  {
    path: "/profile/contracts",
    name: "ProfileContracts",
    meta: {
      layout: "profile",
    },
    component: () => import("@/modules/Profile/pages/PContracts.vue"),
  },
  {
    path: "/profile/contacts",
    name: "ProfileContacts",
    meta: {
      layout: "profile",
    },
    component: () => import("@/modules/Profile/pages/PContacts.vue"),
  },
  {
    path: "/profile/payment-info",
    name: "ProfilePaymentInfo",
    meta: {
      layout: "profile",
    },
    component: () => import("@/modules/Profile/pages/PPaymentInfo.vue"),
  },
  {
    path: "/profile/class-schedule",
    name: "ProfileClassSchedule",
    meta: {
      layout: "profile",
    },
    component: () => import("@/modules/Profile/pages/PClassSchedule.vue"),
  },
];
